// Compiler result to JSON file
    import { createComponent } from 'js/declViewModelService';
    import { registerDynImportEntry } from 'js/moduleLoader';
    import AwParseService from 'js/awParseService';
    import AwFilterService from 'js/awFilterService';
    import { getField } from 'js/utils';
    import { Fragment } from 'react';
    let filterSer = AwFilterService.instance;
    import AwFlexRow from 'viewmodel/AwFlexRowViewModel';
import AwLinkWithPopupMenu from 'viewmodel/AwLinkWithPopupMenuViewModel';
import AwFlexColumn from 'viewmodel/AwFlexColumnViewModel';
import AwCommandBar from 'viewmodel/AwCommandBarViewModel';
import AwInclude from 'viewmodel/AwIncludeViewModel';
    import { ExistWhen } from 'js/hocCollection';
const AwFlexRowExistWhen = ExistWhen(AwFlexRow);
AwFlexRowExistWhen.displayName = 'AwFlexRowExistWhen';

    

    /*
    ctx imports
    */
    
    const ctxImportObj = {  };
    

    /*
    dynamic import
    */
    registerDynImportEntry('js/DesCatalogPartConfigService', () => import('js/DesCatalogPartConfigService'));;

    /*
    view model
    */
    const declViewModelJson = {
    "schemaVersion": "1.0.0",
    "dataProviders": {
        "searchViewer": {
            "dataProviderType": "Static",
            "response": "{{data.allViewersData}}",
            "totalFound": "{{data.allViewersData.length}}",
            "inputData": {
                "selectionData": "{{fields.selectionData}}"
            }
        }
    },
    "props": {
        "accsessionid": {
            "type": "string"
        },
        "provider": {
            "type": "string"
        },
        "catalogspaceid": {
            "type": "string"
        }
    },
    "data": {
        "selectionData": {
            "initialValues": {},
            "meta": {}
        },
        "ViewerTextLink": {
            "displayName": "",
            "type": "STRING",
            "isRequired": "true"
        },
        "allViewersData": [],
        "viewerIndex": 0,
        "viewerSRC": "",
        "viewerName": {
            "type": "STRING",
            "dbValue": ""
        },
        "displayView": "xyz"
    },
    "actions": {
        "customSelectionChangeAction": {
            "actionType": "JSFunction",
            "method": "handleSelectionChangeForViewers",
            "inputData": {
                "localSelectionData": "{{data.atomicData.selectionData}}",
                "vmo": "{{data}}"
            },
            "deps": "js/DesCatalogPartConfigService"
        },
        "updateAllViewersSRC": {
            "actionType": "JSFunction",
            "method": "updateAllViewersSRC",
            "inputData": {
                "vmo": "{{data}}",
                "allViewersInfo": "{{parameters.eventData}}"
            },
            "deps": "js/DesCatalogPartConfigService"
        },
        "nextViewer": {
            "actionType": "JSFunction",
            "method": "nextViewer",
            "inputData": {
                "vmo": "{{data}}"
            },
            "deps": "js/DesCatalogPartConfigService"
        },
        "previousViewer": {
            "actionType": "JSFunction",
            "method": "previousViewer",
            "inputData": {
                "vmo": "{{data}}"
            },
            "deps": "js/DesCatalogPartConfigService"
        },
        "getPartDetails": {
            "actionType": "JSFunctionAsync",
            "method": "getPartDetails",
            "inputData": {
                "vmo": "{{data}}",
                "props": "{{props}}",
                "selectedObjects": "{{parameters.eventData}}"
            },
            "deps": "js/DesCatalogPartConfigService"
        }
    },
    "i18n": {},
    "onEvent": [
        {
            "eventId": "updateAllViewersSRC",
            "action": "updateAllViewersSRC",
            "inputArgs": {
                "vmo": "{{data}}",
                "eventData": "{{eventData.eventData}}"
            }
        },
        {
            "eventId": "partSummaryTableRowProvider.selectionChangeEvent",
            "cacheEventData": false,
            "action": "getPartDetails",
            "inputArgs": {
                "eventName": "partSummaryTableRowProvider.selectionChangeEvent",
                "eventData": "{{eventData.selectedObjects}}"
            }
        },
        {
            "eventId": "nextView",
            "action": "nextViewer"
        },
        {
            "eventId": "previousView",
            "action": "previousViewer"
        },
        {
            "eventId": "getPartDetails.success",
            "cacheEventData": false,
            "action": "updateAllViewersSRC",
            "inputArgs": {
                "eventData": "{{eventData}}"
            }
        }
    ],
    "lifecycleHooks": {
        "onUpdate": [
            {
                "action": "customSelectionChangeAction",
                "observers": [
                    "viewModel.atomicData.selectionData"
                ]
            }
        ]
    },
    "_viewModelId": "DesCatalogCarousel",
    "_uniqueViewModelId": "DesCatalogCarousel",
    "ctx": {
        "carouselVisibiliy": {
            "type": "object"
        }
    }
};

    /*
    <!-- When carousel is enabled -->
<aw-flex-row height="0.75" class="viewer-aw-link-with-popup-menu" exist-when="ctx.carouselVisibiliy === true">
    <aw-link-with-popup-menu prop="data.ViewerTextLink" dataprovider="data.dataProviders.searchViewer" id="orgMenu">
    </aw-link-with-popup-menu>
</aw-flex-row>
<aw-flex-row height="11" class="viewer-carousel-styling" exist-when="ctx.carouselVisibiliy === true">
    <div width="1" class="carousel-styling">
        <aw-flex-column>
            <aw-command-bar overflow="false" anchor="aw_leftCarouselAnchor" alignment="VERTICAL">
            </aw-command-bar>
        </aw-flex-column>
    </div>
    <aw-flex-column width="9" class="catalog-viewer-styling">
        <aw-include name="{{data.viewerName.dbValue}}" sub-panel-context='{viewerSRC:data.viewerSRC}'>
        </aw-include>
    </aw-flex-column>
    <div width="1" class="carousel-styling">
        <aw-flex-column>
            <aw-command-bar overflow="false" anchor="aw_rightCarouselAnchor" alignment="VERTICAL">
            </aw-command-bar>
        </aw-flex-column>
    </div>
</aw-flex-row>

<!-- When carousel is disabled -->
<aw-flex-row height="12" class="viewer-carousel-styling" exist-when="ctx.carouselVisibiliy !== true">
    <aw-flex-column width="12" class="catalog-viewer-styling">
        <aw-include name="{{data.viewerName.dbValue}}" sub-panel-context='{viewerSRC:data.viewerSRC}'>
        </aw-include>
    </aw-flex-column>
</aw-flex-row>

    */
    const renderFn =(props)=> {
        let subPanelContext = props.subPanelContext ;
        let { viewModel: { data, dataProviders, dispatch, conditions, selectionModels, editHandlers, chartProviders, ports  }, grids, ctx, actions, fields, messages, i18n, formProp, viewPath  } = props;
        data = {...data, dataProviders};
        if( subPanelContext && subPanelContext.fields ){
            fields = { ...fields, ...subPanelContext.fields };
        }
        let $index = null;
        return (
            <Fragment>
    <AwFlexRowExistWhen height="0.75" className="viewer-aw-link-with-popup-menu" existWhen={AwParseService.instance( "ctx.carouselVisibiliy === true" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )}>
        <AwLinkWithPopupMenu {...getField("data.ViewerTextLink", fields, $index, null, null )} dataprovider={AwParseService.instance( "data.dataProviders.searchViewer" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )} id="orgMenu">
        </AwLinkWithPopupMenu>
    </AwFlexRowExistWhen>
    <AwFlexRowExistWhen height="11" className="viewer-carousel-styling" existWhen={AwParseService.instance( "ctx.carouselVisibiliy === true" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )}>
        <div width="1" className="carousel-styling">
            <AwFlexColumn>
                <AwCommandBar overflow={AwParseService.instance( "false" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )} anchor="aw_leftCarouselAnchor" alignment="VERTICAL">
                </AwCommandBar>
            </AwFlexColumn>
        </div>
        <AwFlexColumn width="9" className="catalog-viewer-styling">
            <AwInclude viewId={AwParseService.instance( "data.viewerName.dbValue" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )} viewPath={AwParseService.instance( "viewPath" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )} name={AwParseService.instance( "data.viewerName.dbValue" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )} subPanelContext={AwParseService.instance( "{viewerSRC:data.viewerSRC}" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )}>
            </AwInclude>
        </AwFlexColumn>
        <div width="1" className="carousel-styling">
            <AwFlexColumn>
                <AwCommandBar overflow={AwParseService.instance( "false" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )} anchor="aw_rightCarouselAnchor" alignment="VERTICAL">
                </AwCommandBar>
            </AwFlexColumn>
        </div>
    </AwFlexRowExistWhen>
    <AwFlexRowExistWhen height="12" className="viewer-carousel-styling" existWhen={AwParseService.instance( "ctx.carouselVisibiliy !== true" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )}>
        <AwFlexColumn width="12" className="catalog-viewer-styling">
            <AwInclude viewId={AwParseService.instance( "data.viewerName.dbValue" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )} viewPath={AwParseService.instance( "viewPath" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )} name={AwParseService.instance( "data.viewerName.dbValue" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )} subPanelContext={AwParseService.instance( "{viewerSRC:data.viewerSRC}" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )}>
            </AwInclude>
        </AwFlexColumn>
    </AwFlexRowExistWhen>
</Fragment>
        )
    };


    /*
    define component
    */
    const Component = createComponent( declViewModelJson, renderFn, undefined, ctxImportObj );

    export default Component;